import React from "react";
import { useTranslation } from "react-i18next";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  messagingTabsListClassName,
  messagingTabsTriggerClassName,
} from "../utils/constants";
import { MessagingSettingsTab } from "../utils/types";

export function MessagingPageTabsNav() {
  const { t } = useTranslation();

  return (
    <div className="mb-6 flex items-center justify-center">
      <TabsList className={messagingTabsListClassName}>
        <TabsTrigger
          value={MessagingSettingsTab.ARRIVAL}
          className={messagingTabsTriggerClassName}
        >
          {t("layout.messagingSettingsPage.tabs.arrivalMessage")}
        </TabsTrigger>
        <TabsTrigger
          value={MessagingSettingsTab.BOOKING}
          className={messagingTabsTriggerClassName}
        >
          {t("layout.messagingSettingsPage.tabs.bookingConfirmation")}
        </TabsTrigger>
        <TabsTrigger
          value={MessagingSettingsTab.EMAIL_TEMPLATES}
          className={messagingTabsTriggerClassName}
        >
          {t("layout.messagingSettingsPage.tabs.emailTemplates")}
        </TabsTrigger>
      </TabsList>
    </div>
  );
}
